var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "88",
        "height": "88",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('defs', [_c('linearGradient', {
      attrs: {
        "x1": "50%",
        "y1": "0%",
        "x2": "50%",
        "y2": "100%",
        "id": "a"
      }
    }, [_c('stop', {
      attrs: {
        "stop-color": "var(--homeIconColorShowTop)",
        "offset": "0%"
      }
    }), _c('stop', {
      attrs: {
        "stop-color": "var(--homeIconColorShowBot)",
        "offset": "100%"
      }
    })])]), _c('g', {
      attrs: {
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('circle', {
      attrs: {
        "stroke": "url(#a)",
        "stroke-width": "2",
        "cx": "44",
        "cy": "44",
        "r": "43"
      }
    }), _c('path', {
      attrs: {
        "d": "M28 28h32v32H28z"
      }
    }), _c('path', {
      attrs: {
        "d": "M50.677 56.699H36.414a2.006 2.006 0 01-1.911-1.974 1.933 1.933 0 011.935-1.98c.059 0 .119 0 .178.008h14.168a2.223 2.223 0 012.131 1.972 2.257 2.257 0 01-2.238 1.974zm-18.624-5.707a3.056 3.056 0 01-3.045-2.78v-14.4a3.063 3.063 0 013.381-2.764h22.639a3.072 3.072 0 013.381 2.764V48.41a3.217 3.217 0 01-3.147 2.574c-.078 0-.157 0-.235-.009H32.39c-.11.012-.222.018-.333.018h-.003zm17.435-7.128c-.287 0-.52.113-.52.252v3.554c0 .139.233.252.52.252h1.644c.287 0 .52-.113.52-.252v-3.553c0-.14-.233-.252-.52-.252l-1.644-.001zm-4.807-2.566a.476.476 0 00-.52.411v5.804a.476.476 0 00.52.411h1.645a.476.476 0 00.519-.411v-5.804a.476.476 0 00-.52-.411h-1.644zm-5.15-2.308a.538.538 0 00-.519.555v7.824a.538.538 0 00.519.555h1.645a.538.538 0 00.519-.555v-7.827a.538.538 0 00-.52-.555l-1.644.003zm-4.81-2.846c-.286 0-.519.327-.519.73v10.319c0 .403.233.73.52.73h1.646c.287 0 .52-.327.52-.73V36.875c0-.404-.233-.731-.52-.731h-1.647z",
        "fill": "var(--homeIconCenterColor)",
        "fill-rule": "nonzero"
      }
    })])]));
  }
};